import { reportManagerIsDateRangeByDays, reportManagerIsDateRangeRequired, sanitizeReportManagerQueuePayloadDateRange } from '@sigma-frontend-libs/commons'

import { getLocaleDateString, isEmpty, proxy } from '@/utils'

import { serviceNameViaPoint } from '@/components/services/report-manager/queue/utils'
import { filterBy } from '@/components/services/report-manager/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [
    proxy({ type: 'object' }),
    filterBy
  ],

  props: {
    isNew: Boolean,
    loading: Boolean,
    paddless: Boolean
  },

  computed: {
    dateRangeIsRequired() {
      return reportManagerIsDateRangeRequired(this.proxy.type)
    },
    /**
     * Проверяет, выбирается ли диапазон дат выбранного типа отчёта с точностью до дня.
     *
     * @returns {boolean}
     */
    dateRangeIsByDays() {
      return reportManagerIsDateRangeByDays(this.proxy.type)
    },
    dateRangeIsEmpty() {
      const range = this.proxy.dateRange
      if (!range) {
        return true
      }

      return Object.keys(range).every(key => {
        return isEmpty(range?.[key])
      })
    },
    /**
     * Пояснение к выбору периода по дням: общее до выбора дат и с датами после выбора.
     *
     * @returns {string | undefined}
     */
    dateRangeByDaysInfo() {
      if (!this.dateRangeIsByDays) {
        return
      }

      const { gte, lt } = this.proxy.dateRange ?? {}
      if (!gte || !lt) {
        return this.getTranslate(`${serviceNameViaPoint}.infos.dateRangeByDays.empty`)
      }

      return this.getTranslate(`${serviceNameViaPoint}.infos.dateRangeByDays.selected`, {
        from: getLocaleDateString(gte),
        to: getLocaleDateString(lt)
      })
    },

    validation() {
      let dateRangeValidation = true
      if (this.dateRangeIsRequired) {
        dateRangeValidation = !this.dateRangeIsEmpty
      }

      return Boolean(this.proxy.type) && dateRangeValidation && !this.filterByRequiredFieldsIsEmpty
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    },
    'proxy.type'() {
      this.resetDateRangeByType()
    }
  },

  methods: {
    /**
     * Очищает dateRange, если текущий тип отчёта
      * не поддерживает этот фильтр по общему контракту.
     *
     * @returns {void}
     */
    resetDateRangeByType() {
      sanitizeReportManagerQueuePayloadDateRange(this.proxy)
    }
  },

  mounted() {
    this.resetDateRangeByType()
    this.$emit('validation', this.validation)
  },

  render
}
